import styledComp from 'styled-components';
import styled from '@mui/styles/styled';
import { DialogActions } from '@mui/material';
import { Colors, Styling } from '../../../../constants';

export const ActionContainer = styledComp.div`
  display: flex;
  justify-content: center;
  align-items: center;

  button {
    margin-left: ${Styling.DEFAULT_SPACING}px;
  }
`;

export const DialogContentContainer = styledComp.div`
  display: flex;
  border-bottom: 1px solid ${Colors.BLACK_10};
  max-height: 420px;
  margin-top: ${Styling.DEFAULT_SPACING}px;
  margin-bottom: ${Styling.DEFAULT_SPACING}px; 
  margin-left: ${Styling.DEFAULT_SPACING}px;
  margin-right: ${Styling.DEFAULT_SPACING}px;
`;

export const SelectedAssetsContainer = styledComp.div`
  display: flex;
  flex-direction: column;
  min-width: 300px;
  max-width: 400px;
  margin-right: ${Styling.DEFAULT_SPACING}px;
`;

export const EditAssetDetailsContainer = styledComp.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  flex-grow: 1;
  border-bottom: 1px solid ${Colors.BLACK_10};
  margin-left: ${Styling.DEFAULT_SPACING}px;
`;

export const SelectedAssetsItemList = styledComp.div`
  display: flex;
  flex-direction: column;
  align-items: left;
  overflow-y: auto;
  background-color: ${Colors.SELECTED_ITEM};
`;

export const SelectedAssetsInfoText = styledComp.span`
  font-weight: bold;
  font-size: 16px;
  margin-bottom: ${Styling.DEFAULT_SPACING}px;
`;

export const SelectedAssetText = styledComp.span`
  display: flex;
  padding: ${Styling.DEFAULT_SPACING_HALVED}px;
  margin-bottom: 8px;
`;

export const DialogHeaderTitle = styledComp.span`
  font-weight: bold;
  font-size: 20px
`;

export const DialogHeader = styledComp.div`
  display: flex;
  align-items: center;

  padding: ${Styling.DEFAULT_SPACING}px;
  background-color: #f7f7f7;
  height: 78px;

  > * {
    margin-right: ${Styling.DEFAULT_SPACING}px !important;
  }
`;

export const DialogActionsOverride = styled(DialogActions)({
});

export const AssetPropertyRow = styledComp.div`
  display: flex;
  flex-direction: column;
`;

export const AssetCategoryTitle = styledComp.div`
  font-size: 120%;
  font-weight: 400;
  padding: 15px 0 5px;
  text-transform: capitalize;
`;
